import mitt from 'mitt';
import defaultSlotList from '@/components/page-model/slotList';
import { reactive } from 'vue';
import { message } from 'ant-design-vue';
import modalBox from '@/components/form-modal/modal-tools';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import { update_post_sale } from '@/api/mjstore-model';

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY);
export const event_obj = mitt();
export const btn_list = [
  {
    name: '编辑',
    clazz: 'primary',
    cb: (data: any) => {
      // const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '编辑产品跟进',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [],
            labelCol: {
              span: 8,
            },
            wrapperCol: {
              span: 16,
            },
          },
          fields: [
            {
              type: 'datepicker',
              name: 'date',
              label: '耗单日期',
              disabled: true,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              showTime: true,
              format: 'YYYY-MM-DD HH:mm',
              valueFormat: 'YYYY-MM-DD HH:mm',
              placeholder: '请填写耗单日期',
            },
            {
              type: 'remoteselect',
              name: 'order_used_record__shop_id',
              label: '销售执行门店',
              disabled: true,
              placeholder: '请选择销售执行门店',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'remoteselect',
              name: 'order_used_record__staff_id',
              label: '销售执行人',
              disabled: true,
              placeholder: '请选择执行人',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-staff',
            },
            {
              type: 'textarea',
              name: 'note',
              label: '使用情况',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              maxlength: 300,
              defaultValue: '',
              placeholder: '请填写使用情况',
            },
            {
              type: 'datepicker',
              name: 'last_date',
              label: '最近跟进日期',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              showTime: true,
              format: 'YYYY-MM-DD HH:mm',
              valueFormat: 'YYYY-MM-DD HH:mm',
              placeholder: '请填写最近跟进日期',
            },
            {
              type: 'remoteselect',
              name: 'shop_id',
              label: '跟进执行门店',
              disabled: false,
              placeholder: '请选择执行门店',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'remoteselect',
              name: 'staff_id',
              label: '跟进执行人',
              disabled: !!current_shop,
              placeholder: '请选择执行人',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-staff',
            },
          ],
          rules: {},
          model: reactive({
            org_id: current_org?.id,
            is_active: true,
            post_sale_id: data.id,
            note: data.note,
            last_date: data.last_date,
            date: data.date,
            shop_id: data.shop_id,
            staff_id: data.staff_id,
          }),
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            update_post_sale(payload)
              .then(() => {
                message.success('编辑产品跟进成功');
                event_obj.emit('refresh');
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};

export const head_btn_list = [
  // {
  //   name: '新建',
  //   clazz: 'primary',
  //   cb: (data: any) => {
  //     const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
  //     const editModal = reactive({
  //       visible: true,
  //       title: '新建售后产品跟进',
  //       form: {
  //         settings: {
  //           labelAlign: 'right',
  //           layout: 'horizontal',
  //           col: [],
  //         },
  //         fields: [
  //           {
  //             type: 'remoteselect',
  //             name: 'order_used_record_id',
  //             label: '关联耗单',
  //             disabled: false,
  //             placeholder: '请选择关联耗单',
  //             datasourceType: 'remote',
  //             mode: 'default',
  //             labelKey: 'order_code',
  //             allowClear: true,
  //             showSearch: true,
  //             modalType: 'mjstore-orderusedrecord',
  //           },
  //           {
  //             type: 'input',
  //             name: 'note',
  //             label: '使用情况',
  //             disabled: false,
  //             allowClear: true,
  //             inputType: 'text',
  //             defaultValue: '',
  //             placeholder: '请填写使用情况',
  //           },
  //           {
  //             type: 'datepicker',
  //             name: 'date',
  //             label: '创建日期',
  //             disabled: false,
  //             allowClear: true,
  //             inputType: 'number',
  //             defaultValue: '',
  //             showTime: true,
  //             format: 'YYYY-MM-DD HH:mm',
  //             valueFormat: 'YYYY-MM-DD HH:mm',
  //             placeholder: '请填写创建日期',
  //           },
  //           {
  //             type: 'datepicker',
  //             name: 'last_date',
  //             label: '最近跟进日期',
  //             disabled: false,
  //             allowClear: true,
  //             inputType: 'number',
  //             defaultValue: '',
  //             showTime: true,
  //             format: 'YYYY-MM-DD HH:mm',
  //             valueFormat: 'YYYY-MM-DD HH:mm',
  //             placeholder: '请填写最近跟进日期',
  //           },
  //           {
  //             type: 'remoteselect',
  //             name: 'shop_id',
  //             label: '执行门店',
  //             disabled: !!current_shop,
  //             placeholder: '请选择执行门店',
  //             datasourceType: 'remote',
  //             mode: 'default',
  //             allowClear: true,
  //             modalType: 'mjstore-shop',
  //           },
  //           {
  //             type: 'remoteselect',
  //             name: 'staff_id',
  //             label: '执行人',
  //             disabled: false,
  //             placeholder: '请选择执行人',
  //             datasourceType: 'remote',
  //             mode: 'default',
  //             allowClear: true,
  //             modalType: 'mjstore-staff',
  //           },
  //         ],
  //         rules: {
  //           order_used_record_id: [{ required: true, message: '请选择关联耗单' }],
  //           date: [{ required: true, message: '请填写创建日期' }],
  //         },
  //         model: reactive({
  //           org_id: current_org?.id,
  //           is_active: true,
  //           customer_id: data.customer_id,
  //           order_used_record_id: null,
  //           note: null,
  //           shop_id: current_shop?.id,
  //           staff_id: null,
  //           last_date: null,
  //           date: null,
  //         }),
  //       },
  //       options: {},
  //       ok: (payload: any) => {
  //         return new Promise(resolve => {
  //           create_post_sale(payload).then(() => {
  //             message.success('新建售后产品跟进成功');
  //             event_obj.emit('refresh');
  //             resolve(null);
  //           });
  //         });
  //       },
  //     });
  //     modalBox(editModal);
  //   },
  // },
];
